import { BASE_URL } from "../config/settings";
import httpRequest from "../utils/httpRequest";

export const deleteLob = async (id) => {
  return await httpRequest(`${BASE_URL}/lob/lob/delete-lob?id=${id}`, "post", {});
};